import React from 'react';
import PropTypes from 'prop-types';
import { InputMi, Row, Col } from '@design-system-etat/dsfr-react';
import { getMessageErreurChampManquant, getPatternHookFormValidation } from 'utils/utils';
import { REGEXP_EMAIL, REGEXP_NOM_PRENOM } from 'constants/contraintes.constants';
import SelectDepartements from 'components/form/referentiel/select/SelectDepartement';

const InformationsUtilisateurNonConnecte = ({ hookForm }) => {
    const { register, formState } = hookForm;

    const validatePrenom = (valuePrenom) => {
        if (!valuePrenom) {
            return getMessageErreurChampManquant('Prénom');
        }
        return null;
    };

    const validateDepartement = (valueDepartement) => {
        if (!valueDepartement) {
            return getMessageErreurChampManquant('Préfecture de rattachement');
        }
        return null;
    };

    return (
        <>
            <Row goutierre>
                <Col col={12} lg={6}>
                    <InputMi
                        label="Nom"
                        required
                        uppercase
                        {...register('nom', {
                            required: getMessageErreurChampManquant('nom'),
                            pattern: getPatternHookFormValidation(REGEXP_NOM_PRENOM, 'nom'),
                        })}
                        error={formState.errors ? formState.errors.nom : null}
                    />
                </Col>
                <Col col={12} lg={6}>
                    <InputMi
                        label="Prénom"
                        required
                        uppercase
                        {...register('prenom', {
                            pattern: getPatternHookFormValidation(REGEXP_NOM_PRENOM, 'prenom'),
                            validate: (value) => validatePrenom(value),
                        })}
                        error={formState.errors ? formState.errors.prenom : null}
                    />
                </Col>
            </Row>
            <Row goutierre>
                <Col col={12} lg={6}>
                    <InputMi
                        label="E-mail"
                        type="text"
                        required
                        {...register('email', {
                            required: getMessageErreurChampManquant('E-mail'),
                            pattern: {
                                value: REGEXP_EMAIL,
                                message: "Le format de l'adresse mail n'est pas valide",
                            },
                        })}
                        error={formState.errors ? formState.errors.email : null}
                    />
                </Col>
            </Row>
            <Row goutierre>
                <Col col={12} lg={6}>
                    <SelectDepartements
                        name="prefecture"
                        label="Préfecture de rattachement"
                        texteAide="Préfecture liée au département de la résidence principale du détenteur"
                        displayRequired
                        placeholder=" "
                        register={register('prefecture', {
                            validate: (value) => validateDepartement(value),
                        })}
                    />
                </Col>
            </Row>
        </>
    );
};

InformationsUtilisateurNonConnecte.propTypes = {
    hookForm: PropTypes.func.isRequired,
};

export default InformationsUtilisateurNonConnecte;
